<template>
  <div class="vermwohnung bg-dimmed round-corners">
    <v-icon v-if="remove"
            class="delete-wohnung"
            @click="$emit('vermieterwohnungdelete')">close
    </v-icon>

    <v-row no-gutters
           class="flex-nowrap">

      <v-col cols="3">
        <div class="mylabel">
          {{ beschreibung }}
        </div>
      </v-col>

      <v-col cols="9">
        <v-row no-gutters class="flex-nowrap">
          <v-col col="6"
                  class="zusatz--column">

            <template v-if="!selectTarifAllowed || wohnungenIndex !== 0">
              <vermieter-sb :sb="sb" />
            </template>

            <v-select v-else
                      v-validate="'required'"
                      :value="sb"
                      :error-messages="errors.collect('sb')"
                      :items="selectableSbs"
                      data-vv-as="Selbstbehalt Wohnung"
                      class="required pa-0"
                      name="sb"
                      @change="updateAllSbs">
              <!--slots used to set color and tooltip-->
              <template slot="item"
                        slot-scope="{ item }">
                <vermieter-sb :sb="item.value" />
              </template>
              <template slot="selection"
                        slot-scope="{ item }">
                <vermieter-sb :sb="item.value" />
              </template>
            </v-select>


          </v-col>

          <v-col cols="6"
                  class="zusatz--column">
            <div class="selected--text">
              {{ $helpers.toGermanFloatString(getVermPrice()) }}&nbsp;€
            </div>
          </v-col>

        </v-row>
      </v-col>
    </v-row>

    <v-row no-gutters>

      <v-spacer />

      <v-col cols="9"
              class="we-input-container">
        <v-text-field v-model="localMiete"
                      v-validate="'required|numeric|min_value:100|max_value:24000'"
                      :error-messages="errors.collect('jahresbruttomiete' + wohnungenIndex)"
                      :name="'jahresbruttomiete' + wohnungenIndex"
                      data-vv-as="Jahresbruttomiete"
                      data-vv-validate-on=""
                      suffix=" €"
                      label="Jahresbruttomiete in €"
                      class="we-input-field required"
                      @input="updateBaseData" />
      </v-col>

    </v-row>

  </div>
</template>

<script>
import VermieterSb from "@/components/privatkundenrechner/VermieterSb";
import KeyTranslator from "@/components/helper/keyTranslatorMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import {RIGHTS} from "@/store/user";

export default {
  name: "ZusatzVermieterWohnung",
  components: { VermieterSb },
  mixins: [twowayBinding, ValidationMixin, KeyTranslator],
  props: {
    wohnungenIndex: {
      type: Number,
      required: true,
    },
    remove: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      localMiete: "0",
      selectableSbs: [
        { value: "SB300", text: "300 €" },
        { value: "SB500", text: "500 €" }
      ]
    };
  },
  computed: {
    // hasError currently not required, see "updateBaseData"
    ...mapTwoWay(["id", "beschreibung", "sb", "bruttojahresmiete"]),
    selectTarifAllowed() {
      return this.$store.getters.checkAuthorization(RIGHTS.TARIFSELECTION);
    },
    currentVermieterPraemien() {
      return this.$store.getters.currentPraemien(this.moduleStatePath).vermieter;
    },
    moduleStatePath() {
      return this.statePath.split(".")[0];
    }
  },
  mounted () {
    if (this.bruttojahresmiete) this.localMiete = this.bruttojahresmiete;
  },
  methods: {
    getVermPrice() {
      let praemie = this.currentVermieterPraemien.find(vermPraemien => vermPraemien.id === this.id);
      return praemie ? praemie.praemie : 0;
    },
    /**
     * commit bruttojahresmiete
     */
    updateBaseData() {
      this.$validator.validate('jahresbruttomiete' + this.wohnungenIndex).then(validationResult => {
        // at the moment required to commit the mutation to trigger evaluation of "vermvalid" in state
        // otherwise, we could just use two way binding:
        // this.bruttojahresmiete = this.localMiete;
        // this.hasError = validationResult;
        const valuesToSet = {
          bruttojahresmiete: this.localMiete,
          hasError: !validationResult //this.errors.has('jahresbruttomiete' + this.wohnungenIndex)
        };
        this.$store.commit("updateWohnung", {
          rootState: this.$store.state,
          statePath: this.moduleStatePath,
          payload: { index: this.wohnungenIndex, data: valuesToSet }
        });
      });
    },
    updateAllSbs(sb) {
      this.$store.commit("updateWohnungenSbs", {
        rootState: this.$store.state,
        statePath: this.moduleStatePath,
        payload: { sb }
      });
    }
  }
};
</script>

<style>
.vermwohnung {
  padding: 16px 0 16px 0;
  position: relative;
  max-width: 510px;
  margin: auto;
}

.vermwohnung .icon {
  cursor: pointer;
  color: rgba(0, 0, 0, .87);
}

.vermwohnung .mylabel {
  padding-left: 16px;
  color: #002C76;
  text-align: left;
  font-size: 16px;
}

.vermwohnung .selected--text {
  color: #0085CF;
  font-size: 16px;
}

.vermwohnung input[type="text"] {
  text-align: right !important;
}

.vermwohnung .input-group--text-field input {
  text-align: right !important;
}

.vermwohnung .we-input-container {
  display: flex;
  justify-content: flex-end;
  margin-right: 48px;
}

.vermwohnung .we-input-field {
  padding-left: 0 !important;
  padding-right: 0 !important;
  max-width: 60% !important;
  margin-top: 16px;
}

.vermwohnung .delete-wohnung {
  position: absolute;
  top: 8px;
  right: 8px;
}

.vermwohnung .zusatz--column .v-select {
  padding: 0 !important;
  max-width: 80px !important;
  margin-left: auto;
  margin-right: -40px;
  margin-top: -3px;
}

</style>


